import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

const WorkspaceReady = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-dark-secondary rounded-full flex items-center justify-center mx-auto mb-8">
          <Check size={32} className="text-white" />
        </div>
        <h1 className="text-4xl font-bold mb-4">Your workspace is ready!</h1>
        <p className="text-gray-400 mb-8">
          These details help us configure AI tagging and insights tailored to
          your needs.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-8 py-3 bg-purple-accent hover:bg-purple-hover rounded-lg font-medium transition-colors"
        >
          Log in
        </button>
      </div>
    </div>
  );
};

export default WorkspaceReady;
